module.exports = __webpack_public_path__ + "static/media/personalActive.9e3eec81.svg";